import * as Types from '../../__generated_types__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetJackpotsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetJackpotsQuery = { __typename?: 'Query', jackpot_ticker?: { __typename?: 'jackpot_ticker', id: string, data?: string | null } | null };


export const GetJackpotsDocument = gql`
    query getJackpots {
  jackpot_ticker {
    id
    data
  }
}
    `;

/**
 * __useGetJackpotsQuery__
 *
 * To run a query within a React component, call `useGetJackpotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJackpotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJackpotsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetJackpotsQuery(baseOptions?: Apollo.QueryHookOptions<GetJackpotsQuery, GetJackpotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJackpotsQuery, GetJackpotsQueryVariables>(GetJackpotsDocument, options);
      }
export function useGetJackpotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJackpotsQuery, GetJackpotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJackpotsQuery, GetJackpotsQueryVariables>(GetJackpotsDocument, options);
        }
export function useGetJackpotsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetJackpotsQuery, GetJackpotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJackpotsQuery, GetJackpotsQueryVariables>(GetJackpotsDocument, options);
        }
export type GetJackpotsQueryHookResult = ReturnType<typeof useGetJackpotsQuery>;
export type GetJackpotsLazyQueryHookResult = ReturnType<typeof useGetJackpotsLazyQuery>;
export type GetJackpotsSuspenseQueryHookResult = ReturnType<typeof useGetJackpotsSuspenseQuery>;
export type GetJackpotsQueryResult = Apollo.QueryResult<GetJackpotsQuery, GetJackpotsQueryVariables>;